import React from 'react'
import { Outlet } from 'react-router-dom'
import { ThemeProvider } from '@mui/material'
import { useSelector } from 'react-redux'
import { getCemFeatures, getUserInfo } from 'src/store/userInfo/userInfoSlice'
import Footer from '../Footer'
import Main from '../Main'
import useAppInsights from '../../../rsmCoreComponents/hooks/appInsights'
import { getHighContrast } from '../../../store/userSettings/userSettingsSlice'
import { accessibilityTheme, normalTheme } from '../../../styles/materialTheme'
import { useAppSelector } from '../../../utils/hooks'
import Popover from '../../Popover/Popover'
import ProfileModalContainer from '../../Profile/ProfileModal/ProfileModalContainer'
import { isFeatureFlagEnabled } from '../../../rsmCoreComponents/utils/featureFlagUtils'
import WelcomeModal from '../../WelcomeModal/WelcomeModal'

const Layout = () => {
  const isHighContrast = useAppSelector(getHighContrast)
  const userInfo = useSelector(getUserInfo)
  const cemFeatures = useSelector(getCemFeatures)

  return (
    <ThemeProvider theme={isHighContrast ? accessibilityTheme : normalTheme}>
      <Popover />
      <Main>
        <Outlet />
      </Main>
      <Footer />
      {isFeatureFlagEnabled(
        'UserProfile',
        userInfo.emailAddress,
        cemFeatures,
      ) && <ProfileModalContainer />}
      <WelcomeModal />
    </ThemeProvider>
  )
}

export default useAppInsights(Layout)
